import { render, staticRenderFns } from "./tab6.vue?vue&type=template&id=717a1f63&scoped=true&"
import script from "./tab6.vue?vue&type=script&lang=js&"
export * from "./tab6.vue?vue&type=script&lang=js&"
import style0 from "./tab6.vue?vue&type=style&index=0&id=717a1f63&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717a1f63",
  null
  
)

export default component.exports